module.exports = __webpack_public_path__ + "img/seminar (29).8f6be63e.jpg";